import makeService from './api';

export default makeService('material_media');
